import { Component, OnInit, Input } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { InvoicesService } from 'apis/ewallet';
import { MyInvoicesService } from 'src/app/services/my-invoices.service';
import { UtilService } from 'src/app/services/util.service';
import { Invoice } from '../../../../apis/ewallet/model/invoice';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
})
export class InvoiceComponent implements OnInit {

  @Input() itemData: Invoice;
  @Input() myIndex: number;

  constructor(public alertController: AlertController,
              public utilService: UtilService,
              public myInvoicesService: MyInvoicesService,
              private invoicesService: InvoicesService) { }

  ngOnInit() {}

  async presentAlertMultipleButtons() {
    // https://ionicframework.com/docs/api/alert
    // https://ionicframework.com/docs/api/alert-controller
    const alert = await this.alertController.create({
      header: 'Quero confirmar entrega de R$ ' + this.itemData.value + ' para ' + this.itemData.user.name,
      inputs: [
        {
          name: 'invoiceSendText',
          type: 'text',
          placeholder: 'texto (opcional)...'
        }
      ],
      buttons: [
        {
          text: 'Sim',
          handler: (data) => {
            this.confirm(data);
          }
        },
        {
          text: 'Não',
          handler: (data) => {
            this.cancel(data);
          }
        },
        {
          text: 'não fazer nada',
          handler: () => {
            console.log('não fazer nada');
          }
        }
      ]
    });
    await alert.present();
  }

  confirm(handlerData: object) {
    this.myInvoicesService.confirm(this.myIndex);
  }

  cancel(handlerData: object) {
    this.myInvoicesService.cancel(this.myIndex, handlerData['invoiceSendText']);
  }

}
